import React from 'react';

type ContentFormProps = { children: React.ReactNode };

const ContentForm = ({ children }: ContentFormProps) => {
	return (
		<>
			<div
				className="vtex-login-2-x-content content content--emailAndPassword vtex-login-2-x-content--emailAndPassword flex relative bg-base justify-around overflow-visible pa4 center items-baseline-ns items-baseline"
				style={{ background: 'white', position: 'relative' }}
			>
				<div className="vtex-login-2-x-contentForm contentForm contentFormVisible dn vtex-login-2-x-contentFormVisible db  ph4">
					{children}
				</div>
			</div>
		</>
	);
};

export default ContentForm;
